const configuredApiBase = String(process.env.REACT_APP_API_BASE || '').trim();

export const API_BASE_URL = configuredApiBase
  ? configuredApiBase.replace(/\/$/, '')
  : (typeof window !== 'undefined' ? window.location.origin : '');

export const apiFileUrl = (path, endpoint = '/api/files/download') => {
  if (!path) return '#';
  return `${API_BASE_URL}${endpoint}?path=${encodeURIComponent(path)}`;
};
